import Image from '@/components/UI/Image';
import EFDeltaProIcon1 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon1';
import EFDeltaProIcon10 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon10';
import EFDeltaProIcon2 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon2';
import EFDeltaProIcon3 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon3';
import EFDeltaProIcon4 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon4';
import EFDeltaProIcon5 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon5';
import EFDeltaProIcon6 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon6';
import EFDeltaProIcon7 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon7';
import EFDeltaProIcon8 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon8';
import EFDeltaProIcon9 from '@/components/UI/svg/DeltaPro/Icon/EFDeltaProIcon9';
import { intlNumber } from '@/utils';
import { getImageSpec } from '@/utils/locals';
import { useGlobal } from '@/utils/useGlobal';
import { useMount } from 'ahooks';
import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
import { useImperativeHandle } from 'react';
import css from './index.module.scss';
gsap.registerPlugin(ScrollToPlugin);

export default function TabInfo({ cRef }: any) {
    const { useState, useLang, useRef, useRouter } = useGlobal();
    const ref = useRef();
    const { t } = useLang('delta_pro_new');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['uk', 'au', 'jp', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const lowerHrs = typeof t('Hrs') === 'string' ? t('Hrs').toLowerCase() : t('Hrs')?.props?.lang?.toLowerCase();
    type tab = {
        key: number;
        name: string;
        desc: string;
        icons: {
            id: number;
            title: string;
            hour: string;
            unit: string;
            icon: any;
        }[];
    };

    const isAr = locale == 'sa';

    const getFinalUnit = (baseUnit: string, arabUnit: string) => {
        return isAr ? arabUnit : baseUnit;
    };

    const tabs: tab[] = [
        {
            key: 1,
            name: t('small_kWh'),
            desc: t('small_kWh_desc'),
            icons: [
                {
                    id: 0,
                    title: 'Phone',
                    hour: '313',
                    unit: getFinalUnit(t('Times'), t('Times1')),
                    icon: <EFDeltaProIcon1 />,
                },
                {
                    id: 1,
                    title: 'Laptop',
                    hour: '57',
                    unit: getFinalUnit(t('Times'), t('Times1')),
                    icon: <EFDeltaProIcon2 />,
                },
                {
                    id: 2,
                    title: 'Light',
                    hour: '4',
                    unit: getFinalUnit(t('Day'), t('Day3')),
                    icon: <EFDeltaProIcon3 />,
                },
                {
                    id: 3,
                    title: 'Refrigerator',
                    hour: isAr ? '1-2' : '1-2',
                    unit: getFinalUnit(t('Day'), t('Day4')),
                    icon: <EFDeltaProIcon4 />,
                },
                {
                    id: 4,
                    title: 'Electric Drill',
                    hour: '3',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs3')),
                    icon: <EFDeltaProIcon5 />,
                },
                {
                    id: 5,
                    title: 'Microwave',
                    hour: intlNumber(locale, 2.5),
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs4')),
                    icon: <EFDeltaProIcon6 />,
                },
                {
                    id: 6,
                    title: 'Electric Kettle',
                    hour: intlNumber(locale, 2.2),
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs4')),
                    icon: <EFDeltaProIcon7 />,
                },
                {
                    id: 7,
                    title: 'Electric Oven',
                    hour: isAr ? '2' : '2',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs2')),
                    icon: <EFDeltaProIcon8 />,
                },
                {
                    id: 8,
                    title: 'Air Conditioner',
                    hour: `${intlNumber(locale, 1.8)}-${intlNumber(locale, 3.6)}`,
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs4')),
                    icon: <EFDeltaProIcon9 />,
                },
                {
                    id: 9,
                    title: 'Electric Heater',
                    hour: intlNumber(locale, 1.5),
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs4')),
                    icon: <EFDeltaProIcon10 />,
                },
            ],
        },
        {
            key: 2,
            name: t('middle_kWh'),
            desc: t('middle_kWh_desc'),
            icons: [
                {
                    id: 0,
                    title: 'Phone',
                    hour: '1095',
                    unit: getFinalUnit(t('Times'), t('Times1')),
                    icon: <EFDeltaProIcon1 />,
                },
                {
                    id: 1,
                    title: 'Laptop',
                    hour: '200',
                    unit: getFinalUnit(t('Times'), t('Times1')),
                    icon: <EFDeltaProIcon2 />,
                },
                {
                    id: 2,
                    title: 'Light',
                    hour: '16',
                    unit: getFinalUnit(t('Day'), t('Day1')),
                    icon: <EFDeltaProIcon3 />,
                },
                {
                    id: 3,
                    title: 'Refrigerator',
                    hour: `${intlNumber(locale, 3.5)}-7`,
                    unit: getFinalUnit(t('Day'), t('Day3')),
                    icon: <EFDeltaProIcon4 />,
                },
                {
                    id: 4,
                    title: 'Electric Drill',
                    hour: '10',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs3')),
                    icon: <EFDeltaProIcon5 />,
                },
                {
                    id: 5,
                    title: 'Microwave',
                    hour: intlNumber(locale, 8.8),
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs4')),
                    icon: <EFDeltaProIcon6 />,
                },
                {
                    id: 6,
                    title: 'Electric Kettle',
                    hour: intlNumber(locale, 7.7),
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs4')),
                    icon: <EFDeltaProIcon7 />,
                },
                {
                    id: 7,
                    title: 'Electric Oven',
                    hour: '7',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs3')),
                    icon: <EFDeltaProIcon8 />,
                },
                {
                    id: 8,
                    title: 'Air Conditioner',
                    hour: `${intlNumber(locale, 6.3)}-${intlNumber(locale, 12.6)}`,
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs4')),
                    icon: <EFDeltaProIcon9 />,
                },
                {
                    id: 9,
                    title: 'Electric Heater',
                    hour: intlNumber(locale, 5.2),
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs4')),
                    icon: <EFDeltaProIcon10 />,
                },
            ],
        },
        {
            key: 3,
            name: t('large_kWh'),
            desc: t('large_kWh_desc'),
            icons: [
                {
                    id: 0,
                    title: 'Phone',
                    hour: '2159',
                    unit: getFinalUnit(t('Times'), t('Times1')),
                    icon: <EFDeltaProIcon1 />,
                },
                {
                    id: 1,
                    title: 'Laptop',
                    hour: '393',
                    unit: getFinalUnit(t('Times'), t('Times1')),
                    icon: <EFDeltaProIcon2 />,
                },
                {
                    id: 2,
                    title: 'Light',
                    hour: '31',
                    unit: getFinalUnit(t('Day'), t('Day1')),
                    icon: <EFDeltaProIcon3 />,
                },
                {
                    id: 3,
                    title: 'Refrigerator',
                    hour: '7-14',
                    unit: getFinalUnit(t('Day'), t('Day1')),
                    icon: <EFDeltaProIcon4 />,
                },
                {
                    id: 4,
                    title: 'Electric Drill',
                    hour: '20',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs1')),
                    icon: <EFDeltaProIcon5 />,
                },
                {
                    id: 5,
                    title: 'Microwave',
                    hour: '17',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs1')),
                    icon: <EFDeltaProIcon6 />,
                },
                {
                    id: 6,
                    title: 'Electric Kettle',
                    hour: '15',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs1')),
                    icon: <EFDeltaProIcon7 />,
                },
                {
                    id: 7,
                    title: 'Electric Oven',
                    hour: '13',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs1')),
                    icon: <EFDeltaProIcon8 />,
                },
                {
                    id: 8,
                    title: 'Air Conditioner',
                    hour: '12-24',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs1')),
                    icon: <EFDeltaProIcon9 />,
                },
                {
                    id: 9,
                    title: 'Electric Heater',
                    hour: '10',
                    unit: getFinalUnit(locale === 'de' ? t('Hrs') : lowerHrs, t('Hrs3')),
                    icon: <EFDeltaProIcon10 />,
                },
            ],
        },
    ];

    const [tabIndex, setTabIndex] = useState(1);
    const [tabPosition, setTabPosition] = useState({
        tabWidth: 123,
        offsetLeft: 212,
    });

    const linkBox = useRef();

    const changeTabIndex = (e: any) => {
        const index = e.target.dataset.index;
        originalChange(index, e.target);
        e.preventDefault();
    };

    const originalChange = (index: number, target: any) => {
        const { clientWidth, offsetLeft } = target;
        setTabIndex(index);
        setTabPosition({ tabWidth: clientWidth, offsetLeft: offsetLeft });
    };

    const [isExpanIcon, setIsExpanIcon] = useState(false);
    const changeExpanIconPanel = () => {
        if (!isExpanIcon) {
            const container = ref.current;
            const ele = container.querySelector('.tabs');

            if (!ele) return;
            gsap.to(window, {
                scrollTo: {
                    y: ele,
                    offsetY: 20,
                },
            });
        }
        setIsExpanIcon(!isExpanIcon);
    };

    useMount(() => {
        try {
            originalChange(1, linkBox?.current.childNodes[0].childNodes[0]);
        } catch (e) {}
    });

    // 父组件调用方法
    useImperativeHandle(cRef, () => ({
        changeExpanIconFlag: (isExpanIcon: boolean) => setIsExpanIcon(isExpanIcon),
    }));

    return (
        <>
            <div ref={ref} className={`${css.tab_info} GtmModuleData-section`} data-section-id={css.tab_info} data-section-title={tabs[0].name}>
                <div className="img-container">
                    <div className="tab_info_img">
                        <div className={`deltaproall ${Number(tabIndex) === 1 ? 'show' : 'hide'}`}>
                            <div>
                                <Image
                                    src={
                                        locale === 'ph'
                                            ? 'https://websiteoss.ecoflow.com/upload/image/1751092728146/1.png'
                                            : `/media/deltapro/pc/${imgSpec}/05/1.png`
                                    }
                                    alt={tabs[0].name}
                                    width={1920}
                                    height={951}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="tab_info_img">
                        <div className={`deltaproall ${Number(tabIndex) === 2 ? 'show' : 'hide'}`}>
                            <Image
                                src={
                                    locale === 'ph'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1751092727565/2.png'
                                        : `/media/deltapro/pc/${imgSpec}/05/2.png`
                                }
                                alt={tabs[1].name}
                                width={1920}
                                height={951}
                            />
                        </div>
                    </div>
                    <div className="tab_info_img">
                        <div className={`deltaproall ${Number(tabIndex) === 3 ? 'show' : 'hide'}`}>
                            <Image
                                src={
                                    locale === 'ph'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1751092727963/3.png'
                                        : `/media/deltapro/pc/${imgSpec}/05/3.png`
                                }
                                alt={tabs[2].name}
                                width={1920}
                                height={951}
                            />
                        </div>
                    </div>
                </div>

                <div className="tabsPanel">
                    <div className="tabs" ref={linkBox}>
                        {tabs.map((tab: tab) => (
                            <div key={tab.key} className={`tab font-family-semibolder ${tab.key === Number(tabIndex) ? 'select' : ''}`}>
                                <a href="#" data-index={tab.key} onClick={changeTabIndex} aria-label={tab.name}>
                                    {tab.name}
                                </a>
                            </div>
                        ))}
                    </div>
                    <div
                        className="line"
                        style={{
                            width: `calc(${tabPosition.tabWidth}px)`,
                            left: `calc(${tabPosition.offsetLeft}px)`,
                        }}
                    />
                    <div className="content">
                        <p className="desc font-family-semibolder">{tabs.find((tab) => tab.key === Number(tabIndex))?.desc}</p>
                        <div onClick={changeExpanIconPanel} className="action font-family-semibold">
                            {t('WCIP')}
                            <i style={{ lineHeight: 0 }}>
                                <Image
                                    src="/icons/arrow-blue1.svg"
                                    className={`arraw ${isExpanIcon ? 'reverse' : ''}`}
                                    width={21}
                                    height={21}
                                    alt={t('icon')}
                                />
                            </i>
                        </div>
                        <div className={`icons ${isExpanIcon ? '' : 'hide'}`}>
                            <div className="icon-content">
                                {tabs
                                    .find((tab) => tab.key === Number(tabIndex))
                                    ?.icons.map((icon, index) => (
                                        <div key={icon.id} className={`icon_item ${index < 5 ? 'line1' : 'line2'}`}>
                                            <div className="icon_img">{icon.icon}</div>
                                            <p className="t font-family-regular">{t(icon.title)}</p>
                                            <p className="h">
                                                <strong className="font-family-bold">{icon.hour}</strong>
                                                <span className="font-family-semibold">{icon.unit}</span>
                                            </p>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <p className={`footnote font-family-regular ${isExpanIcon ? '' : 'hide'}`}>{t('capacity_notice')}</p>
                    </div>
                </div>
            </div>
        </>
    );
}
